const button = {
    login: 'Sign in',
    logout: 'Logout',
    submit: 'Submit',

    create: 'Create',
    view: 'View',
    download: 'Download',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    updateClose: 'Update & Close',

    add: 'Add',
    save: 'Save',
    new: 'Add New',
    clone: 'Clone',
    remove: 'Remove',
    reset: 'Reset',
    enforce: 'Enforce',
    optional: 'Optional',

    addStatus: 'Add Status',
    updateStatus: 'Update Status',
    search: 'Detailed Search',

    termTranscript: 'Term',
    yearTranscript: 'Year',
    yearFpTranscript: 'Year (Foundation Program)',
    yearTranscriptMerged: 'Year (Primary/Secondary Major)',
    yearFullTranscript: 'Year and Full (Primary/Secondary Major)',
    fullTranscript: 'Full',
    mabrTranscript: 'MABR',

    accept: 'Accept',
    reject: 'Reject',

    pdf: 'PDF',
    excel: 'Excel',
    word: 'Word',
    classList: 'Class List',
    detailedSearch: 'Detailed Search',
    close: 'Close',
    saveChanges: 'Save Changes',
    addCourse: 'Add Course',
    send: 'Send',
    generateReport: 'Generate Report',
    goBack: 'Go Back',

    uploadFiles: 'Upload Files',
    goBackHome: 'Go back to Home',
    continue: 'Continue',

    generate: 'Generate',
    cancel: 'Cancel',

    undo: 'Undo',
    clear: 'Clear',
    exportPDF: 'Export as PDF',
    exportList: 'Export List',
    getPaymentData: 'Get Payment Data',

    generateSecret: 'Generate Secret Key to Enable 2FA',
    enable2FA: 'Enable Two Factor Authentication',
    disable2FA: 'Disable Two Factor Authentication',
    skip2FA: 'Skip for now',
    rescan: 'Wanna scan barcode?',
    reset2FA: 'Reset 2FA with recovery code',

    bookList: 'Book List',
    newInvoice: 'Create new invoice',
    createPaymentPlanFPInvoices: 'Create payment plan invoices (foundation program)',
    createpaymentplanInvoices: 'Create payment plan invoices',
    createPaymentPlanInvoicesForSecondary: 'Create payment plan invoices (secondary major)',

    enabled: 'Enabled',
    disabled: 'Disabled',

    professor: 'Add professor',
    newProfessor: 'Add new professor',

    call: 'Call',
    email: 'Send e-mail',

    manageProgram: 'Manage Program',
    addProgramCourses: 'Add Program Courses',

    resetFilter: 'Reset Filter',

    addBundle:'Add Bundle',
    addBook: 'Add Book',
    
    exportPdf: 'Grade Report',

    programCoursesReport: 'Courses Report',
}

export default button;